module.exports = __webpack_public_path__ + "static/navarro_college-cd1d1ff1a506d1d9bc8f01e7920763c4.png";